import Box from '@mui/material/Box';
import React from 'react';

import { AttendanceSummaryPanel } from './panels/AttendanceSummaryPanel';
import { BillingPanel } from './panels/BillingPanel';
import { InvoicesPanel } from './panels/InvoicesPanel';
import { ReviewCompliancePanel } from './panels/ReviewCompliancePanel';
import { SLADetailsPanel } from './panels/SLADetailsPanel';
import type { useServiceDetailData } from './useServiceDetailData';

export interface ServiceAdminTabProps {
  serviceId: number;
  data: ReturnType<typeof useServiceDetailData>;
}

/**
 * Administration tab content: review + billing on the left, attendance + SLA
 * details on the right. Visibility is gated on the
 * Service_Edit_Administration_Section permission AND non-client status —
 * both checks live in the parent ServiceDetail.
 */
export const ServiceAdminTab: React.FC<ServiceAdminTabProps> = ({ serviceId, data }) => (
  <Box
    sx={{
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: 1.75,
      px: 2.5,
      pt: 1.75,
      alignItems: 'start',
    }}
  >
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.75 }}>
      <ReviewCompliancePanel
        billingInfo={data.billingInfoData}
        onSave={data.handleSaveBillingInfo}
      />
      <BillingPanel billing={data.billing} />
      <InvoicesPanel
        internalInvoices={data.internalInvoices}
        externalInvoices={data.externalInvoices}
      />
    </Box>
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.75 }}>
      <AttendanceSummaryPanel
        attendance={data.attendanceData as unknown as Array<Record<string, unknown>>}
        metrics={data.attendanceMetrics}
      />
      <SLADetailsPanel serviceId={serviceId} />
    </Box>
  </Box>
);
